module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_3016.2e59992e.png";